import React from "react";
import { Box } from "@mui/material";
import FemaleIcon from "@mui/icons-material/Female";
import MaleIcon from "@mui/icons-material/Male";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import { getRoomRestrictionType } from "../../utils/roomRestriction";

export default function RoomRestrictionBadge({ restriction }) {
  const type = getRoomRestrictionType(restriction);
  if (!type) return null;

  const GenderIcon = type === "male" ? MaleIcon : FemaleIcon;

  return (
    <Box
      component="span"
      aria-label={`${type} room restriction`}
      title={`${type} room restriction`}
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 36,
        height: 36,
        flexShrink: 0,
      }}
    >
      <SmartToyOutlinedIcon sx={{ fontSize: 32, color: "text.secondary" }} />
      <GenderIcon
        sx={{
          position: "absolute",
          right: -2,
          bottom: -2,
          fontSize: 18,
          color: type === "male" ? "info.main" : "secondary.main",
          bgcolor: "background.paper",
          borderRadius: "50%",
        }}
      />
    </Box>
  );
}
